import { Component, ChangeDetectorRef, OnDestroy, OnInit } from '@angular/core'
import { Subscription } from 'rxjs'

import { appConstants } from '../../app.constants'
import { ConnectivityService } from '../../common/services/offline/connectivity.service'
import { SyncQueueService } from '../../common/services/offline/sync-queue.service'

@Component({
  selector: 'app-network-notification',
  templateUrl: './network-notification.component.html',
  styleUrls: ['./network-notification.component.scss']
})
export class NetworkNotificationComponent implements OnInit, OnDestroy {
  isOnline = true
  displayIsOnline: boolean
  isSyncing = false
  pendingCount = 0
  failedCount = 0

  private subscriptions = new Subscription()
  private displayTimeout: any

  constructor(
    private connectivityService: ConnectivityService,
    private syncQueueService: SyncQueueService,
    private cdr: ChangeDetectorRef
  ) {}

  ngOnInit() {
    this.subscriptions.add(
      this.connectivityService.isOnline$.subscribe(online => {
        const wasOffline = !this.isOnline
        this.isOnline = online

        if (wasOffline && online) {
          this.displayIsOnline = true
          this.displayTimeout = setTimeout(() => {
            this.displayIsOnline = false
            this.cdr.detectChanges()
          }, appConstants.FLASH_MESSAGE_TIMEOUT)
        }

        this.cdr.detectChanges()
      })
    )

    this.subscriptions.add(
      this.syncQueueService.isSyncing$.subscribe(syncing => {
        this.isSyncing = syncing
      })
    )

    this.subscriptions.add(
      this.syncQueueService.pendingCount$.subscribe(count => {
        this.pendingCount = count
      })
    )

    this.subscriptions.add(
      this.syncQueueService.failedCount$.subscribe(count => {
        this.failedCount = count
      })
    )
  }

  ngOnDestroy() {
    this.subscriptions.unsubscribe()
    if (this.displayTimeout) {
      clearTimeout(this.displayTimeout)
    }
  }

  retrySync() {
    this.syncQueueService.processQueue()
  }
}
